// CTA Banner Templates Configuration
export const CTA_TEMPLATES = [
  {
    id: 'offer',
    name: 'Offer / Discount',
    description: 'Coaches, course sellers, SaaS signups',
    icon: '🏷️',
    defaultContent: {
      headline: 'Special Offer',
      tagline: 'Limited time discount',
      price: '$99',
      originalPrice: '$199',
      showPrice: true
    }
  },
  {
    id: 'lead_magnet',
    name: 'Lead Magnet Download',
    description: 'Free resources, guides, ebooks',
    icon: '📥',
    defaultContent: {
      headline: 'Free Download',
      tagline: 'Get your free guide now',
      showSecondaryButton: true,
      secondaryButtonText: 'Learn More'
    }
  },
  {
    id: 'book_call',
    name: 'Book a Call',
    description: 'Consultations, coaching sessions',
    icon: '📞',
    defaultContent: {
      headline: 'Book Your Free Call',
      tagline: 'Limited spots available this week',
      showCalendarBadge: true,
      showProfilePhoto: true
    }
  },
  {
    id: 'offer_stack',
    name: 'Webinar Offer Stack',
    description: 'Value stacks, bundles, packages',
    icon: '📦',
    defaultContent: {
      headline: 'Everything You Get',
      listItems: ['Item 1 ($99 Value)', 'Item 2 ($149 Value)', 'Item 3 ($79 Value)'],
      totalValue: '$327',
      price: '$97'
    }
  },
  {
    id: 'newsletter',
    name: 'Join Newsletter / Community',
    description: 'Email lists, communities, groups',
    icon: '✉️',
    defaultContent: {
      headline: 'Join Our Community',
      tagline: 'Get exclusive updates and tips',
      showEmailField: true
    }
  },
  {
    id: 'product_spotlight',
    name: 'Product Spotlight',
    description: 'Product showcases, demos',
    icon: '✨',
    defaultContent: {
      headline: 'Introducing Our Product',
      tagline: 'The solution you\'ve been waiting for',
      showSpotlightImage: true
    }
  },
  {
    id: 'event_registration',
    name: 'Event Registration',
    description: 'Upcoming events, workshops',
    icon: '📅',
    defaultContent: {
      headline: 'Register Now',
      eventDate: 'December 15, 2024',
      eventTime: '2:00 PM EST',
      showSpeakerPhoto: true
    }
  },
  {
    id: 'blank',
    name: 'Blank Canvas',
    description: 'Full creative control',
    icon: '🎨',
    defaultContent: {
      headline: '',
      tagline: ''
    }
  }
];

export const DISPLAY_MODES = [
  {
    id: 'vertical',
    name: 'Vertical',
    description: 'Left or right sidebar',
    icon: '↕️',
    positions: ['left', 'right']
  },
  {
    id: 'horizontal',
    name: 'Horizontal',
    description: 'Top or bottom strip',
    icon: '↔️',
    positions: ['top', 'bottom', 'left', 'right']
  },
  {
    id: 'centered',
    name: 'Centered',
    description: 'Overlay block in center',
    icon: '⬚',
    positions: ['center']
  }
];

export const FONTS = [
  'Inter',
  'Poppins',
  'Roboto',
  'Open Sans',
  'Montserrat',
  'Lato',
  'Playfair Display',
  'Oswald',
  'Raleway'
];

export const BUTTON_SIZES = [
  { id: 'sm', name: 'Small', padding: '8px 16px', fontSize: '12px' },
  { id: 'md', name: 'Medium', padding: '12px 24px', fontSize: '14px' },
  { id: 'lg', name: 'Large', padding: '16px 32px', fontSize: '16px' }
];

export const ANIMATIONS = [
  { id: 'none', name: 'None' },
  { id: 'fade', name: 'Fade' },
  { id: 'slide', name: 'Slide' },
  { id: 'zoom', name: 'Zoom' },
  { id: 'bounce', name: 'Bounce' }
];

export const getDefaultCTAData = (templateId) => {
  const template = CTA_TEMPLATES.find(t => t.id === templateId);
  return {
    templateId,
    displayMode: 'centered',
    position: 'center',
    name: '',
    headline: {
      text: template?.defaultContent?.headline || '',
      font: 'Inter',
      size: 28,
      weight: 'bold',
      color: '#ffffff',
      alignment: 'center',
      italic: false
    },
    tagline: {
      text: template?.defaultContent?.tagline || '',
      font: 'Inter',
      size: 16,
      weight: 'normal',
      color: '#ffffffcc',
      alignment: 'center',
      italic: false
    },
    bodyText: {
      text: '',
      font: 'Inter',
      size: 14,
      weight: 'normal',
      color: '#ffffff99',
      alignment: 'center'
    },
    buttons: [
      {
        text: 'Get Started',
        url: '',
        size: 'md',
        bgColor: '#00c853',
        textColor: '#ffffff',
        hoverColor: '#00b348',
        borderRadius: 8,
        useGradient: false,
        gradientColor2: '#6a1fbf'
      }
    ],
    secondaryButton: {
      enabled: false,
      text: 'Learn More',
      url: '',
      size: 'md',
      bgColor: 'transparent',
      textColor: '#ffffff',
      borderColor: '#ffffff',
      borderRadius: 8
    },
    image: {
      url: '',
      position: 'top',
      size: 'medium',
      borderRadius: 8,
      shadow: true
    },
    background: {
      type: 'gradient',
      color: '#6a1fbf',
      gradientColor2: '#001233',
      gradientDirection: '135deg',
      imageUrl: '',
      imageOpacity: 100,
      overlayColor: '#00000080',
      blur: false
    },
    pricing: {
      enabled: false,
      price: '',
      originalPrice: '',
      currency: '$'
    },
    listItems: [],
    eventDetails: {
      enabled: false,
      date: '',
      time: ''
    },
    animation: {
      entry: 'fade',
      exit: 'fade'
    },
    padding: {
      top: 24,
      right: 24,
      bottom: 24,
      left: 24
    },
    maxWidth: 800,
    backdropBlur: true
  };
};
